export function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i += 1) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(prefix) === 0) {
      return cookie.slice(prefix.length);
    }
  }

  return null;
}
